import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environment/environment';

export interface FilePreviewUrlOptions {
  width?: number;
  format?: string;
}

@Pipe({
  name: 'filePreviewUrl',
})
export class FilePreviewUrlPipe implements PipeTransform {
  transform(
    filePath: string | null | undefined,
    options?: FilePreviewUrlOptions,
  ): string {
    if (!filePath) {
      return '';
    }

    const width = options?.width ?? 128;
    const format = options?.format ?? 'jpg';
    const url = new URL(`/img/preview.${format}`, environment.staticUrl);

    url.searchParams.set('path', filePath);
    url.searchParams.set('w', String(width));

    return url.toString();
  }
}
